import { Pipe, PipeTransform } from "@angular/core";
import { CertificationType } from "@app/training/training.models";

@Pipe({ name: "certTypeIcon" })
export class CertTypeIconPipe implements PipeTransform {
	transform(certType: CertificationType, certified: boolean): string {
		return CertificationType.getImageUrl(certType, "c_scale,h_32", certified);
	}
}
